import { render, staticRenderFns } from "./UsersPendingActivationPage.vue?vue&type=template&id=7fd7496c"
import script from "./UsersPendingActivationPage.vue?vue&type=script&lang=js"
export * from "./UsersPendingActivationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports